export const FEATURE_TOGGLE_SICK_LEAVE_HOURS =
  import.meta.env.VITE_FEATURE_TOGGLE_SICK_LEAVE_HOURS === '1'

export const FEATURE_TOGGLE_CALENDAR_INTEGRATION =
  import.meta.env.VITE_FEATURE_TOGGLE_CALENDAR_FEATURE === '1'

export const FEATURE_TOGGLE_PAY_DATA =
  import.meta.env.VITE_FEATURE_TOGGLE_PAY_DATA === '1'

/**
 * We're using this feature toggle for when BND
 * sends us events through a web socket.
 */
export const FEATURE_TOGGLE_WEBSOCKETS =
  import.meta.env.VITE_FEATURE_TOGGLE_WEBSOCKETS === '1'

/**
 * We're using this feature toggle for when BND starts sending us keys
 * in the web sockets response rather than the whole object that needs to
 * be updated. With this approach, we'll do a GET request with the provided key
 * so we can take the data, no matter how big, that we're tracking through the
 * web socket.
 */
export const FEATURE_TOGGLE_WEBSOCKETS_LINKING =
  import.meta.env.VITE_FEATURE_TOGGLE_WEBSOCKETS_LINKING === '1'

export const FEATURE_TOGGLE_POST_SHIFT_REVIEW =
  import.meta.env.VITE_FEATURE_TOGGLE_POST_SHIFT_REVIEW === '1'

export const FEATURE_TOGGLE_SEGMENT =
  import.meta.env.VITE_FEATURE_TOGGLE_SEGMENT === '1'

export const FEATURE_TOGGLE_WORK_WITH_FRIENDS =
  import.meta.env.VITE_FEATURE_TOGGLE_WORK_WITH_FRIENDS === '1'

export const FEATURE_TOGGLE_ONBOARDING_WORKFLOWS =
  import.meta.env.VITE_FEATURE_TOGGLE_ONBOARDING_WORKFLOWS === '1'

export const FEATURE_TOGGLE_REDIRECT_TO_SPLIT_DOMAINS =
  import.meta.env.VITE_FEATURE_TOGGLE_REDIRECT_TO_SPLIT_DOMAINS === '1'

export const FEATURE_TOGGLE_WORK_OFF_YOUR_STRIKES =
  import.meta.env.VITE_FEATURE_TOGGLE_WORK_OFF_YOUR_STRIKES === '1'

export const FEATURE_TOGGLE_MY_EXPERIENCE =
  import.meta.env.VITE_FEATURE_TOGGLE_MY_EXPERIENCE === '1'

export const FEATURE_TOGGLE_UPSHIFTER_EDITING_HOURS =
  import.meta.env.VITE_FEATURE_TOGGLE_UPSHIFTER_EDITING_HOURS === '1'

export const FEATURE_TOGGLE_MULTIDAY_REVAMP =
  import.meta.env.VITE_FEATURE_TOGGLE_MULTIDAY_REVAMP === '1'

export const FEATURE_TOGGLE_ANALYZE_PHOTO_ERRORS =
  import.meta.env.VITE_FEATURE_TOGGLE_ANALYZE_PHOTO_ERRORS === '1'

export const FEATURE_TOGGLE_INTERVIEW_BOT =
  import.meta.env.VITE_FEATURE_TOGGLE_INTERVIEW_BOT === '1'
